import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";
import { useApiClient } from "../../api/ApiContext";
import { queryKeys } from "../../api/queryKeys";
import { balancesWithBookingsSchema } from "../../api/timeAccountSchemas";
import type { BalancesWithBookings } from "../../api/timeAccountSchemas";
import type { LocalDate } from "../../domain/time";

/**
 * Loads the own balances on a key date (`GET /me/balances`), for „Salden“ and the start page
 * „Heute“ (F-75); both share the answer of today. Another date keeps the shown balances while it
 * loads.
 *
 * @param asOf - The key date.
 * @returns The query result.
 */
export function useBalances(asOf: LocalDate): UseQueryResult<BalancesWithBookings> {
  const client = useApiClient();
  const query = useQuery({
    queryKey: queryKeys.balances(asOf),
    queryFn: ({ signal }) =>
      client.get("/api/v1/me/balances", balancesWithBookingsSchema, { query: { asOf }, signal }),
    placeholderData: keepPreviousData,
  });

  return query;
}
